<template>
  <div class="all-teams-wrap" v-if="list && list.length !== 0" :class="{'with-time': showTime}">
    <div v-if="showTime" class="time-row">
      <UiLabel shadow-color="#880000" text-color="#fff">
        开始时间: {{ formatTime(info.startAt) }}
      </UiLabel>
      <UiLabel shadow-color="#880000" text-color="#fff">
        结束时间: {{ formatTime(info.endAt) }}
      </UiLabel>
    </div>
    <!-- 所有队伍 -->
    <ul class="allTeams">
      <li
          v-for="(team, key, index) in list"
          :key="key"
          @click="handleQuiz(info, team, team, index)"
      >
        <div class="icon-bg">
          <div class="name">
            <UiLabel shadow-color="#FFFFFF" text-color="#880000">
              {{ team.name ? team.name : '-' }}
            </UiLabel>
          </div>
          <div class="icon">
            <div
                class="head"
                :style="{
              'background-image': `url(${team.avatar ? team.avatar : ''})`,
            }"
            ></div>
            <div class="frame"></div>
          </div>
        </div>

        <div class="info">
          <UiLabel class="odd" shadow-color="#FFFFFF" text-color="#333333">
            赔率 {{ team.lossRate ? team.lossRate : '0' }}
          </UiLabel>
          <UiLabel class="rating" shadow-color="#FFFFFF" text-color="#333333">
            支持率 {{ team?.popularity ? Number(team.popularity * 100).toFixed(0) : '0' }} %
          </UiLabel>
        </div>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { computed, inject } from 'vue'
import UiLabel from '@/components/ui-label'

const handleQuiz = inject('handleQuiz')

const props = defineProps({
  info: {
    type: Object,
    default: () => {}
  },
  list: {
    type: Array,
    default: () => []
  }
})

const showTime = computed(() => {
  return props.info.answers.length === 0;
})

function formatTime(val) {
  let date = new Date(val);
  let hour = date.getHours();
  hour = hour < 10 ? "0" + hour : hour;
  let min = date.getMinutes();
  min = min < 10 ? "0" + min : min;

  return ` ${hour}:${min} `;
}
</script>

<style lang="scss" scoped>
.all-teams-wrap {
  position: relative;   // 给 .time-row (absolute) 提供定位参考
}

.time-row {
  position: absolute;
  top: get_vw(16);
  left: get_vw(21);
  z-index: 1;
  display: flex;
  font-size: get_vw(24);
  // 第 2 个及以后 label 加左间距 (原 inline margin-right 0.5vw ≈ get_vw(7.36), 取整 8)
  > :nth-child(n+2) {
    margin-left: get_vw(18);
  }
}

// 所有队伍
.allTeams {
  position: relative;
  padding: get_vw(18) 0 get_vw(6);
  display: grid;
  // 6 列 fixed 宽度: 每列 228 = li 内容 212 + margin 双侧 16, 保证 li 精确 212×293; 间距用 margin (项目约定不用 CSS gap)
  grid-template-columns: repeat(6, get_vw(228));
  justify-content: center;   // 6 列组整体水平居中在 allTeams content 里 (padding-x 为 0 时 fit 剩余空间)
  overflow: hidden;

  // 有 time-row 时顶部 padding 加 43 给它让位 (触发条件: 父 wrap 加 .with-time class, 即 showTime=true)
  .all-teams-wrap.with-time & {
    padding-top: get_vw(18 + 32 + 10);
  }

  // 装饰层: 灰白高光背景 + border 都由 ::before 承载, 不占布局
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(180deg, rgba(#C5C1C1, 0.5) 0%, rgba(#FFF, 0.5) 28.85%), #FFF;
    box-sizing: border-box;
    border-style: solid;
    border-color: #FFF;
    border-width: get_vw(4);
    pointer-events: none;
  }
  li {
    box-sizing: border-box;
    position: relative;
    // 宽度由 grid 1fr 分配, 无需 hardcode; margin 制造 item 间距
    height: get_vw(293);
    margin: get_vw(8);
    background-image: url(https://website.xdcdn.net/poster/58881/26match/common/QYH7Fxon.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    filter: drop-shadow(0 get_vw(4) get_vw(4) rgba(#000, 0.1));
    font-size: get_vw(20);
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;

    .icon-bg {
      position: relative;
      width: 100%;
      height: 100%;
      .name {
        position: absolute;
        top: get_vw(12);
        width: 100%;
        // 颜色由 ui-label prop 决定
      }
      .icon {
        position: absolute;
        top: get_vw(47);
        left: 50%;
        transform: translate3d(-50%, 0, 0);
        width: get_vw(146);
        height: get_vw(158);
        @include avatar_icon_frame;
      }
    }

    .info {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: get_vw(74);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      // 颜色由 ui-label prop 决定
    }
  }

}
</style>
